import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-user-unauthorize',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './user-unauthorize.component.html',
  styleUrl: './user-unauthorize.component.scss',
})
export class UserUnauthorizeComponent {}
